// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screenshotPdfHeader--XTV7c {
  height: 120px;
  color: white;
  display: flex;
}[dir] .screenshotPdfHeader--XTV7c {
  background: #0e3b83;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.screenshotPdfHeaderItem--fR6mZ {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screenshotPdfHeaderTitle--LkPxT {
  font-size: 26px;
  flex: 1;
}

[dir] .screenshotPdfHeaderTitle--LkPxT {
  padding: 0 15px;
}

[dir=ltr] .screenshotPdfHeaderLogoWrapper--FQvte {
  padding-left: 30px;
}

[dir=rtl] .screenshotPdfHeaderLogoWrapper--FQvte {
  padding-right: 30px;
}

.screenshotPdfHeaderLinkWrapper--xoBWD {
  height: 100%;
  display: flex;
  align-items: center;
}

[dir=ltr] .screenshotPdfHeaderLinkWrapper--xoBWD {
  justify-content: right;
  padding-right: 30px;
}

[dir=rtl] .screenshotPdfHeaderLinkWrapper--xoBWD {
  justify-content: left;
  padding-left: 30px;
}
.screenshotPdfHeaderLink--N0AF3 {
  color: white;
}
[dir] .screenshotPdfHeaderLink--N0AF3 {
  padding: 5px 10px;
  border: 3px solid #f59201;
}

.screenshotPdfHeaderLink--N0AF3:hover {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/ScreenshotHeader/styles.css"],"names":[],"mappings":"AAAA;EAEE,aAAa;EAIb,YAAY;EACZ,aAAa;AACf,CARA;EACE,mBAAmB;EAEnB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AAGxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EAEf,OAAO;AACT;;AAJA;EAEE,eAAe;AAEjB;;AAEA;EACE,kBAAkB;AACpB;;AAFA;EACE,mBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EAEb,mBAAmB;AAErB;;AANA;EAGE,sBAAsB;EAEtB,mBAAmB;AACrB;;AANA;EAGE,qBAAsB;EAEtB,kBAAmB;AACrB;AACA;EAGE,YAAY;AACd;AAJA;EACE,iBAAiB;EACjB,yBAAyB;AAE3B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".screenshotPdfHeader {\n  background: #0e3b83;\n  height: 120px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  color: white;\n  display: flex;\n}\n\n.screenshotPdfHeaderItem {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.screenshotPdfHeaderTitle {\n  font-size: 26px;\n  padding: 0 15px;\n  flex: 1;\n}\n\n.screenshotPdfHeaderLogoWrapper {\n  padding-left: 30px;\n}\n\n.screenshotPdfHeaderLinkWrapper {\n  height: 100%;\n  display: flex;\n  justify-content: right;\n  align-items: center;\n  padding-right: 30px;\n}\n.screenshotPdfHeaderLink {\n  padding: 5px 10px;\n  border: 3px solid #f59201;\n  color: white;\n}\n\n.screenshotPdfHeaderLink:hover {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screenshotPdfHeader": `screenshotPdfHeader--XTV7c`,
	"screenshotPdfHeaderItem": `screenshotPdfHeaderItem--fR6mZ`,
	"screenshotPdfHeaderTitle": `screenshotPdfHeaderTitle--LkPxT`,
	"screenshotPdfHeaderLogoWrapper": `screenshotPdfHeaderLogoWrapper--FQvte`,
	"screenshotPdfHeaderLinkWrapper": `screenshotPdfHeaderLinkWrapper--xoBWD`,
	"screenshotPdfHeaderLink": `screenshotPdfHeaderLink--N0AF3`
};
export default ___CSS_LOADER_EXPORT___;
